module.exports = __webpack_public_path__ + "static/media/Social Machines.020be56c.csv";